export function isAutomatedTest(): boolean {
    return (
        typeof window !== 'undefined' &&
        /bondvet\/automated-tests/.test(navigator?.userAgent ?? '')
    );
}
